import { render, staticRenderFns } from "./batchUploadFile.vue?vue&type=template&id=34da4508&"
import script from "./batchUploadFile.vue?vue&type=script&lang=js&"
export * from "./batchUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34da4508')) {
      api.createRecord('34da4508', component.options)
    } else {
      api.reload('34da4508', component.options)
    }
    module.hot.accept("./batchUploadFile.vue?vue&type=template&id=34da4508&", function () {
      api.rerender('34da4508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FileUpload/batchUploadFile.vue"
export default component.exports